export const TAG_CHARS_LIMIT = 20;
